export const wildcardMatch = (route: string, pathname: string) => {
  // Escape special characters in the pattern and replace wildcards with regex patterns
  const regexPattern = route
    .replace(/[.+^${}()|[\]\\]/g, '\\$&') // Escape special characters
    .replace(/\*/g, '.*'); // Replace * with .*

  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(pathname);
};

export const shouldGetProfileCheck = (routes: string[], pathname: string) => {
  return !routes.some((route) => wildcardMatch(route, pathname));
};
